export const Getters = {
  // implement getters here...
  pageSize: state => state.pageSize,
  getCoordinatorLinkStatus: state => state.coordinatorLinkStatus,
  sideBarMenu: state => state.menu,
  dashboardLayout: state => state.dashboardLayout,
  // topDashboardLayout: (state) => {
  //   return state.topDashboardLayout;
  // },
  leftDrawer: state => state.leftDrawer.state,
  leftDrawerComponent: state => state.leftDrawer.component,
  leftDrawerTitle: state => state.leftDrawer.title,
  dialogState: state => state.dialog,
  dialogOpen: state => state.dialog.open,
  dialogData: state => state.dialog.data,
  dialogComponent: state => state.dialog.component,
  dashboardWidgets: state => state.dashboardLayout.setup,
};
